module.exports = __webpack_public_path__ + "static/media/arrow-down.94542c1c.svg";